/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect, useMemo, useState} from 'react'
import {TabCentralModel} from '../../../../../../models'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useCentral} from '../../../../../../hooks/useCentral'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {ClaimModelDocument} from '../../../../model/claim.model'
import {getClaims} from '../../../../services/claim.service'
import {formatDateDDMMYYYY} from '../../../../../../util/dates'
import {getMasterService} from '../../../../services'
import {useAuth} from '../../../../../../hooks/useAuth'

const TableModules: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useCentral()
  const {applications} = useAuth()
  const mappedSites = applications.map((item: any) => ({
    value: item.aplicacionId,
    label: item.description,
  }))

  const {searchValues, clearSearchValues} = useKhipu()
  const [typeRequirement, setTypeRequirement] = useState<any>([])
  const [statusRequirement, setStatusRequirement] = useState<any>([])
  const [typeDocument, setTypeDocument] = useState<any>([])
  const [typeClaimant, setTypeClaimant] = useState<any>([])

  const getStatusRequirementList = async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 2000))
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoRequerimiento',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setStatusRequirement(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  const getTypeRequirementList = async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 2000))
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoRequerimiento',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setTypeRequirement(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  const getTypeClaimantList = async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 2000))
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'Reclamante',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setTypeClaimant(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  const getTypeDocumentList = async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 2000))
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoDocumento',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
      }))
      setTypeDocument(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  const getClaimList = async () => {
    try {
      setLoading(true)
      const {data: response} = await getClaims({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...searchValues,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  useEffect(() => {
    getStatusRequirementList()
    getTypeRequirementList()
    getTypeClaimantList()
    getTypeDocumentList()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    getClaimList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])
  useEffect(() => {
    if (Object.keys(searchValues).length === 0) {
      getClaimList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValues])
  const handleViewPanel = (data: any) => {
    const getRow = data.row
    const getArrows = data.data
    const getData = getArrows[getRow.index]
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: true,
      content: {
        ...currentTabItem.content,
        detailPanel: 'tab-claim',
      },
      idToEdit: getData.Id,
      idToDelete: '',
    }
    clearSelected()
    changeCurrentTabItem(obj)
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const columns: Column<ClaimModelDocument>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].Id}
            clickHandler={handleGetId}
            disable={
              props.row.original.EstadoRequerimiento_descripcion?.toUpperCase() !== 'PENDIENTE'
            }
          />
        ),
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Número de Requerimiento'
            name='NroRequerimiento'
            searcheable
          />
        ),
        accessor: 'NroRequerimiento',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha de Requerimiento'
            name='FechaRequerimientoIni'
            dateable
          />
        ),
        accessor: 'FechaRequerimiento',
        Cell: ({...props}) => (
          <div>{formatDateDDMMYYYY(props.row.original.FechaRequerimiento)}</div>
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Requerimiento'
            name='TipoRequerimientoId'
            data={typeRequirement}
            selecteable
          />
        ),
        accessor: 'TipoRequerimiento_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Módulo de Requerimiento'
            name='AplicacionId'
            data={mappedSites}
            selecteable
          />
        ),
        accessor: 'Aplicacion_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Reclamante'
            name='ReclamanteId'
            data={typeClaimant}
            selecteable
          />
        ),
        accessor: 'Reclamante_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nombres' name='Huesped_nombres' searcheable />
        ),
        accessor: 'Huesped_nombre',
        Cell: ({...props}) =>
          props.row.original.Reclamante_descripcion === 'HUESPED' ? (
            <div>{props.row.original.Huesped_nombre}</div>
          ) : (
            <div>{props.row.original.Colaborador_nombre}</div>
          ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Documento'
            name='Huesped_tipoDoc'
            data={typeDocument}
            selecteable
          />
        ),
        accessor: 'Huesped_tipoDoc',
        Cell: ({...props}) =>
          props.row.original.Reclamante_descripcion === 'HUESPED' ? (
            <div>{props.row.original.Huesped_tipoDoc}</div>
          ) : (
            <div>{props.row.original.Colaborador_tipodocumento}</div>
          ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nro de Documento'
            name='Huesped_nroDoc'
            searcheable
          />
        ),
        accessor: 'Huesped_nroDoc',
        Cell: ({...props}) =>
          props.row.original.Reclamante_descripcion === 'HUESPED' ? (
            <div>{props.row.original.Huesped_nroDoc}</div>
          ) : (
            <div>{props.row.original.Colaborador_nrodocumento}</div>
          ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Empresa'
            name='Huesped_empresaNombre'
            searcheable
          />
        ),
        accessor: 'Huesped_empresa',
        Cell: ({...props}) =>
          props.row.original.Reclamante_descripcion === 'HUESPED' ? (
            <div>{props.row.original.Huesped_empresa}</div>
          ) : (
            <div>{props.row.original.Colaborador_empresa}</div>
          ),
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Teléfono' name='Huesped_telefono' searcheable />
        ),
        accessor: 'Huesped_telefono',
        Cell: ({...props}) =>
          props.row.original.Reclamante_descripcion === 'HUESPED' ? (
            <div>{props.row.original.Huesped_telefono}</div>
          ) : (
            <div>{props.row.original.Colaborador_telefono}</div>
          ),
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Email' name='Huesped_email' searcheable />
        ),
        accessor: 'Huesped_email',
        Cell: ({...props}) =>
          props.row.original.Reclamante_descripcion === 'HUESPED' ? (
            <div>{props.row.original.Huesped_email}</div>
          ) : (
            <div>{props.row.original.Colaborador_email}</div>
          ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado de Requerimiento'
            name='EstadoRequerimientoId'
            data={statusRequirement}
            selecteable
          />
        ),
        accessor: 'EstadoRequerimiento_descripcion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            {isAllowed('EDITAR') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleViewPanel(props)}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                </a>
              </div>
            )}
          </>
        ),
      },
    ],
    [typeClaimant, typeDocument, statusRequirement, typeRequirement, selectedOn],
  )

  // useEffect(() => {
  //   setInitialPagination()
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentTabItem.loadingTable])
  // const setInitialPagination = async () => {
  //   const {data: response} = await getCamp(obj, pagination.currentPage)
  //   setPagination({
  //     perPage: 10,
  //     currentPage: 1,
  //     totalResults: response.total,
  //   })
  // }

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {}, [data])

  useEffect(() => {
    if (currentTabItem.loadingTable) {
      clearSelected()
      getClaimList()
    }
  }, [currentTabItem.loadingTable])
  useEffect(() => {
    if (updateTable) {
      clearSelected()
      getClaimList()
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  useEffect(() => {
    if (clearTable) {
      //   setClient([])
      //   setSite([])
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])
  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='mx-2  w-100'>
          <KTable data={data} columns={columns} classNameProps='dataTablecentral' />

          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

const TableClaimWrapper = () => {
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Listado de Requerimientos</Tab>
          </TabList>
          <TabPanel>
            <TableModules />
          </TabPanel>
        </Tabs>
      </div>
    </KTableProvider>
  )
}

export {TableClaimWrapper}
